import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { Checkbox } from '@mui/material';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ADMIN_USER_GROUPS_READ } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';
import FlexBox from 'components/common/FlexBox';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const MAX_REMARK_LENGTH = 40;

const UserListItem = ({ data }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();
  const canRead = usePermission(ADMIN_USER_GROUPS_READ);

  const handleEditClick = useCallback(() => {
    historyContext.push(`/users/${data.id}`);
  }, [historyContext, data]);

  const remark = useMemo(
    () => (data.remark && data.remark.length > MAX_REMARK_LENGTH ? `${data.remark.substring(0, MAX_REMARK_LENGTH)}...` : data.remark),
    [data.remark]
  );

  return (
    <TableRow>
      <TableCell size='small'>
        <Typography title={data.name}>{data.name}</Typography>
      </TableCell>
      <TableCell size='small'>
        <Typography title={data.remark}>{remark}</Typography>
      </TableCell>
      <TableCell size='small' style={{ pointerEvents: 'none' }}>
        <Checkbox checked={data.inactive || false} size='small' sx={{ paddingTop: '0px', paddingBottom: '0px' }} />
      </TableCell>
      <TableCell size='small'>
        <Typography>{t('LONG_DATE', { date: data.lastLoginDate })}</Typography>
      </TableCell>
      <TableCell align='right'>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            color='primary'
            size='small'
            variant='text'
            type='edit'
            tooltip={t('Edit')}
            onClick={handleEditClick}
            disabled={!canRead}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

UserListItem.propTypes = {
  data: PropTypes.object
};

export default UserListItem;
